
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"none","stroke":"currentColor","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('circle',{attrs:{"cx":"15","cy":"15","r":"11.87","stroke-width":"1.6"}}),_c('circle',{attrs:{"cx":"15","cy":"21","r":"1","stroke-width":"1.2"}}),_c('path',{attrs:{"d":"M15 17.42c0-3.75 3.19-3.21 3.19-6.39 0-2.57-5-4.17-6.39 0","stroke-width":"1.6"}})])])
          )
        }
      }
    